import {Page, Tabs, Spinner, Modal, Toast} from '@shopify/polaris';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import StoreIntegration from "./StoreIntegration";
import AppConfiguration from "./AppConfiguration";
import LocationDesignSettings from "./LocationDesignSettings";
import ExtraConfig from "./ExtraConfig";
import {useFormik} from "formik";
import {ApiCall, GetApiCall} from "../../helper/axios";
import {updateModalStatus} from "../../redux/slice/commonSlice";

function HomePageComponent() {
    const {status, store_data, activeModal} = useSelector((store) => store.commonData);
    const {token} = store_data;
    const emailId = 'mg12connect@gmail.com';
    const dispatch = useDispatch();
    const [onLoadLoading, setOnLoadLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (value) => {
        setActiveTab(value)
    };
    const [activeToast, setActiveToast] = useState(false);
    const [activeToastMessage, setActiveToastMessage] = useState('');
    const toggleActive = () => {setActiveToast((activeToast) => !activeToast)};
    const toastMarkup = activeToast ? (
        <Toast content={activeToastMessage} onDismiss={toggleActive} />
    ) : null;

    const tabsOptions = [
        {
            id: 'app-configuration',
            content: 'App Configuration',
            panelID: 'app-configuration',
        },
        {
            id: 'location-design-settings',
            content: 'Location / Design (Settings)',
            panelID: 'location-design-settings',
        },
        {
            id: 'extra-configuration',
            content: 'Extra Configuration',
            panelID: 'extra-configuration',
        },
        {
            id: 'store-integration',
            content: 'Store Integration',
            panelID: 'store-integration',
        },
    ];

    const [initialState, setInitialState] = useState({
        appStatus: true,
        currenciesList: null,
        defaultCurrency: null,
        priceFormat: {label: 'With Currency', value: 0},
        displayFlag: {label: 'Yes', value: 0},
        flagStyle: {label: 'Rectangle', value: 0},
        displayBorder: {label: 'Yes', value: 0},
        borderLineColor: '#cccccc',
        textColor: '#000000',
        textHoverColor: '#000000',
        backgroundColor: '#f4f4f4',
        hoverBackgroundColor: '#f4f4f4',
        switcherLocation: {label: 'Fixed Position', value: 0},
        selectFixedPosition: 3,
        ipBasedLocation: true,
        removeDecimals: false,
        pricingRound: false,
        showCartNotice: false,
        defaultCartNoticeMessage: '<<shop.name>> process all orders in <<shop.currency>>. While the content of your cart is currently displayed in <<shop.selected_currency>>, you will checkout using <<shop.currency>> at the most current exchange rate.',
        cartNoticeMessage: '<<shop.name>> process all orders in <<shop.currency>>. While the content of your cart is currently displayed in <<shop.selected_currency>>, you will checkout using <<shop.currency>> at the most current exchange rate.',
        cartNoticetextColor: '#ffffff',
        cartNoticetextBackgroundColor: '#333333',
        showActualPriceOnHover : false
    });

    const formik = useFormik({
        initialValues: initialState,
        enableReinitialize: true,
        onSubmit: () => {
            // onClickSaveBtnFn()
        }
    });

    const saveDataShopifyFn = async (loader) => {
        formik.setFieldValue([loader], true);
        let data = {...formik.values};
        data = deleteObjectFromObj(data)

        if(loader === 'appStatusLoader'){
            data.appStatus = !data.appStatus;
        }

        const enableDisableAppStatus = await ApiCall('POST', '/save-data-shopify', data, { authentication: token });
        if(enableDisableAppStatus?.data?.statusCode === 200 && enableDisableAppStatus?.data?.data){
            setInitialState({...initialState, ...enableDisableAppStatus?.data?.data})
            setActiveToast(true)
            setActiveToastMessage("Save successfully!");
        }else{
            setActiveToast(true)
            setActiveToastMessage("Something went wrong!");
        }
        formik.setFieldValue([loader], false)
    }

    let deleteObjectFromObj = (data) => {
        delete data?.appStatusLoader;
        delete data?.saveLoader;
        delete data?.designSettingsLoader;
        delete data?.locationSettingLoader;
        delete data?.cartNoticeLoader;
        delete data?.pricingRuleLoader;
        return data
    }


    useEffect(() => {
        if(token){
            onLoadFn()
            checkValidIntegration()
        }
    },[token])

    const checkValidIntegration = async () => {
        const enableDisableAppStatus = await ApiCall('POST', '/validate-integration', {}, { authentication: token });
        if(!enableDisableAppStatus?.data?.data){
            dispatch(updateModalStatus(true));
        }
    }

    const onLoadFn = async () => {
        try {
            setOnLoadLoading(true);
            const response = await GetApiCall('GET', '/get-app-data', { authentication: token });
            if (response?.data?.statusCode === 200) {
                const metafieldData = response?.data?.data;
                if(metafieldData){
                    setInitialState({...initialState, ...metafieldData})
                }
            } else {
                setOnLoadLoading(false);
            }
        } catch (error) {
            setOnLoadLoading(false);
        } finally {
            setOnLoadLoading(false);
        }
    };


    return (
        <Page title={tabsOptions?.[activeTab]?.content}>
            {activeModal ?
                <Modal
                    open={activeModal}
                    title="Store Integration"
                >
                    <Modal.Section>
                        <StoreIntegration email={emailId}/>
                    </Modal.Section>
                </Modal>
                : <>
                    <Tabs tabs={tabsOptions} selected={activeTab} onSelect={handleTabChange}/>
                    <br/>
                    {!onLoadLoading ? <>
                            {activeTab === 0 ?
                                <>
                                    <AppConfiguration
                                        formik={formik}
                                        saveDataShopifyFn={saveDataShopifyFn}
                                    />
                                </> :
                                activeTab === 1 ?
                                    <>
                                        <LocationDesignSettings
                                            emailId={emailId}
                                            formik={formik}
                                            saveDataShopifyFn={saveDataShopifyFn}
                                        />
                                    </>
                                    : activeTab === 2 ?
                                    <>
                                        <ExtraConfig
                                            formik={formik}
                                            saveDataShopifyFn={saveDataShopifyFn}
                                        />
                                    </>
                                    : activeTab === 3 ?
                                        <StoreIntegration email={emailId}/>
                                        : null
                            }
                        </> :
                        <div style={{textAlign: "center", paddingTop: "20%"}}>
                            <Spinner accessibilityLabel="Spinner example" size="large"/>
                        </div>
                    }
                </>

            }
            {toastMarkup}
        </Page>
    );
}

export default HomePageComponent;
